import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";

// Route luôn được đăng ký trong <Routes> bất kể vai trò đã tải xong hay chưa
// (tránh việc router khớp "*" và redirect về "/" khi vaiTro còn null ở lần
// render đầu sau khi F5 / vào thẳng link). Việc kiểm quyền chỉ diễn ra ở đây,
// sau khi AuthContext đã tải xong vai trò.
export default function RoleGate({ roles, children }) {
  const { vaiTro, loading } = useAuth();

  if (loading) return null;
  if (roles && !roles.includes(vaiTro)) return <Navigate to="/" replace />;

  return children;
}

RoleGate.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
};

RoleGate.defaultProps = {
  roles: undefined,
};
